import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { routes } from '../routes';
import { selectStrategyById } from "../redux/strategy/strategySlice";

const ProtectedComponent = ({ component, ...propsForComponent}) => {
  const Cp = withAuthenticationRequired(component);
  return <Cp {...propsForComponent} />;
}

/**
 * A trading-protected component that wraps a component with trading permission check
 */
export const TradingProtectedComponent = ({ component }) => {
  const profile = useSelector(state => state.userProfile.data);
  const params = useParams();
  const strategyId = params.strategyId;
  const strategy = useSelector(state => selectStrategyById(state, strategyId));
  
  // If not a trader or admin, redirect to dashboard
  if (profile && profile.user_type === 'INVESTOR') {
    return <Navigate to={routes.dashboard} state={{ message: "You don't have permission to access trading features." }} />;
  }
  
  // If strategy doesn't exist, redirect to dashboard
  if (!strategy) {
    return <Navigate to={routes.dashboard} state={{ message: "Strategy not found." }} />;
  }
  
  // If user is not an admin and doesn't own the strategy, redirect to strategy details
  if (profile && profile.user_type !== 'ADMIN' && !strategy.owned) {
    return <Navigate to={routes.strategyDetails.replace(':strategyId', strategyId)} state={{ 
      message: "You can only trade on your own strategies. Admin access required for other strategies." 
    }} />;
  }
  
  // If user type is valid and either owns the strategy or is admin, render the component
  return <ProtectedComponent component={component} />;
};

export default ProtectedComponent
